<nav class="navbar-default navbar-static-side" role="navigation" [hidden]="!auth.currentUser">
    <div>
        <ul class="nav metismenu" id="side-menu">
            <li routerLinkActive="active">
                <a [routerLink]="['/home']">Home</a>
            </li>
            <!-- <li [ngClass]="{ 'mm-active': activeRoute('mobile') }" [hidden]="!showPictures()">
                <a [routerLink]="['/mobile/tabs/pictures']"><span class="nav-label">Mobile</span></a>
            </li> -->
            <li [ngClass]="{ 'mm-active': activeRoute('mobile') }" [hidden]="!showMobilePictures() && !showMobileStacks()">
                <a href="#"><span class="nav-label">Mobile</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active" [hidden]="!showMobilePictures()"><a [routerLink]="['/mobile/tabs/pictures']">Pictures</a></li>
                    <li routerLinkActive="active" [hidden]="!showMobileStacks()"><a [routerLink]="['/mobile/tabs/stacks']">Stacks</a></li>
                    <li routerLinkActive="active"><a routerLink="/mobile/drivers/trip-record">Drivers</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('pictures') }" [hidden]="!showPictures()">
                <a href="#"><span class="nav-label">Pictures</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/pictures/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/pictures/sales-orders']">Sales Orders</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/pictures/pack-slips']">Pack Slips</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/pictures/invoices']">Invoices</a></li>
                </ul>
            </li>
            <!-- <li [ngClass]="{ 'mm-active': activeRoute('overviews') }" [hidden]="!showOverviews()">
                <a href="#"><span class="nav-label">Overview</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/part-overview']">Parts</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/partsbydate']">Parts By Date</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/process-queue-overview']">Process Queue</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/inventory-date']">Inventory By Date</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/part-instock']">Part InStock</a></li>
                </ul>
            </li> -->

            <li [ngClass]="{ 'mm-active': activeRoute('reports') }" [hidden]="!showReports()">
                <a href="#"><span class="nav-label">Reports</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/reports/open-orders']">Open Orders</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/reports/warranties']">Warranties</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/part-overview']">Parts</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/partsbydate']">Parts By Date</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/process-queue-overview']">Process Queue</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/inventory-date']">Inventory By Date</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/overviews/part-instock']">Part InStock</a></li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/overviews/timing']"
                            >Timing
                            <span class="badge badge-sm text-bg-success ms-1">NEW</span>
                        </a>
                    </li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/reports/customer-reviews']"
                            >Customer Feedback
                            <span *ngIf="this.utility.customerReviewCount() !== 0" class="badge badge-sm text-bg-success">{{this.utility.customerReviewCount()}}</span>
                        </a>
                    </li>
                    <li routerLinkActive="active" [hidden]="!showStatusReview()"><a [routerLink]="['/reports/status-review']">Status Review</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('sales-reporting') }" [hidden]="!showSales()">
                <a href="#"><span class="nav-label">Sales</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/sales-reporting/quotes']">Quotes</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-reporting/expenses/overview']">Expense Report</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-reporting/by-part']">Sales By Part</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-reporting/commissions']">Commissions</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('sales-orders') }" [hidden]="!showSalesOrders()">
                <a href="#"><span class="nav-label">Sales Orders</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/search']">Open Sales Orders</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/build-detail']">Build Detail</a></li>
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/sales-orders/build-list']">Build Lists </a></li> -->
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/map']">Map</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/email']">Emails</a></li>
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/sales-orders/trailer']">Trailers</a></li> -->
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/scheduler']">Scheduler</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/sales-orders/history']">Search</a></li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/sales-orders/warranty-registrations']"
                            >Registrations
                            <span *ngIf="this.utility.registrationCount() !== 0" class="badge badge-sm text-bg-success">{{this.utility.registrationCount()}}</span>
                        </a>
                    </li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('schedule') }" [hidden]="!showSalesOrders()">
                <a href="#"><span class="nav-label">Scheduling</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/schedule/assembly']">Assembly</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/schedule/shipping']">Shipping</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/schedule/stacks']" [hidden]="!showDelivery()">Stacks</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/schedule/deliveries']" [hidden]="!showDelivery()">Deliveries</a></li>
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/schedule/vendor-pickup']">Vendor PickUps</a></li>
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/schedule/history']" [hidden]="!showDelivery()">Search</a></li> -->
                    <li routerLinkActive="active">
                        <a [routerLink]="['/schedule/build-scheduler']" [hidden]="!showBuildSchedule()">Build Scheduler</a>
                    </li>
                    <li routerLinkActive="active">
                        <a [routerLink]="['/schedule/scheduler']" [hidden]="!showBuildSchedule()">Schedule</a>
                    </li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('build-assemblies') }" [hidden]="!showBuildAssembly()">
                <a href="#"><span class="nav-label">Build Assembly</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/build-assemblies/overview']">Overview</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('confirmations') }" [hidden]="!showConfirmations()">
                <a href="#"><span class="nav-label">Confirmations</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/confirmations/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/confirmations/messages']">Messages </a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/confirmations/history']">Search</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('packingslips') }" [hidden]="!showInvoices()">
                <a href="#"><span class="nav-label">Pack Slips</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/invoices/search']">Search</a></li> -->
                    <li routerLinkActive="active"><a [routerLink]="['/packingslips/search']">Open PackSlips</a></li>
                    <!-- <li routerLinkActive="active"><a [routerLink]="['/packingslips/pictures']" [hidden]="!showPictures()">Pack Slip Pictures</a></li> -->
                    <li routerLinkActive="active"><a [routerLink]="['/packingslips/pack-slip-history']">Search</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('invoices') }" [hidden]="!showInvoices()">
                <a href="#"><span class="nav-label">Invoices</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/invoices/open']">Open Invoices</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/invoices/search']">Recent Invoices</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/invoices/history']">Search</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('payments') }" [hidden]="!showPayments()">
                <a href="#"><span class="nav-label">Payments</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/payments/search']">Recent Payments</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/payments/ach-overview']">ACHs</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/payments/history']">Search</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/payments/credits']">Credits</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('parts') }" [hidden]="!showParts()">
                <a href="#"><span class="nav-label">Parts</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/parts/search']">Search</a></li>
                    <li routerLinkActive="active" [hidden]="!showPartCost()"><a [routerLink]="['/parts/cost']">Price Cost Comparisons</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/inventory']" [hidden]="!showPartsInventory()">Inventory</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/usage']" [hidden]="!showPartsInventory()">Inventory Usage </a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/frames']">Frames</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/bulk-edit']" [hidden]="!showPartsBulkEdit()">Bulk Edit</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/projections/overview']" [hidden]="!showProjections()">Projections</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/configuration']" [hidden]="!showPartConfigs()">Part Configs</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/parts/pricing']" [hidden]="!showPricing()">Part Pricing</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('weld-shop') }" [hidden]="!showWeldShop()">
                <a href="#"><span class="nav-label">Weld Shop</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/weld-shop/overview']">Overview</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('purchase-orders') }" [hidden]="!showPurchaseOrders()">
                <a href="#"><span class="nav-label">Purchase Orders</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/purchase-orders/search']">Overview</a></li>
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/purchase-orders/receivings']">Receivings</a></li>
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/purchase-orders/billing']">Bills</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/purchase-orders/email']">Emails</a></li>
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/purchase-orders/history']">History</a></li>
                    <li routerLinkActive="active" [hidden]="false"><a [routerLink]="['/purchase-orders/vendor-pickup']">Vendor PickUps</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('dealers') }" [hidden]="!showDealers()">
                <a href="#"><span class="nav-label">Dealers</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/dealers/overview']">Overview</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/dealers/entry']">Entry</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/dealers/notes']">Notes</a></li>
                </ul>
            </li>
            <li [ngClass]="{ 'mm-active': activeRoute('vendors') }" [hidden]="!showVendors()">
                <a href="#"><span class="nav-label">Vendors</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/vendors/overview']">Overview</a></li>
                </ul>
            </li>

            <li [ngClass]="{ 'mm-active': activeRoute('contact-log') }" [hidden]="!showContactLog()">
                <a href="#"><span class="nav-label">Contact Log</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/contact-log/overview']">Overview</a></li>
                </ul>
            </li>

            <!-- <li [ngClass]="{ 'mm-active': activeRoute('expenses') }" [hidden]="!showExpenseReports()">
                <a href="#"><span class="nav-label">Expense Reports</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/expenses/overview']">Overview</a></li>
                </ul>
            </li> -->

            <li [ngClass]="{ 'mm-active': activeRoute('admin') }" [hidden]="!showAdmin()">
                <a href="#"><span class="nav-label">Admin</span></a>
                <ul class="nav nav-second-level mm-collapse" routerLinkActive="in">
                    <li routerLinkActive="active"><a [routerLink]="['/admin/email-info']">Email Info</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/lookup-tables']">Lookup Tables</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/users']">Users</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/adjustments']">Inv. Adj. History</a></li>
                    <li routerLinkActive="active"><a [routerLink]="['/admin/part-configurator']">Part Configurator</a></li>
                </ul>
            </li>
        </ul>
        <div style="padding: 30px 25px 0px; font-size: 8pt" title="{{ appInfo.clientVersion }}">version: <strong>{{ appInfo.clientVersion }}</strong></div>
        <div style="padding: 5px 25px; font-size: 8pt">user: {{ auth.currentUser?.userName }}</div>
    </div>
</nav>
